import type { UiStrings } from "../types";

export const ko: UiStrings = {
  nav: {
    category: "카테고리",
    forYourWork: "업무별 도구",
    searchPlaceholder: "300개 이상의 도구 검색...",
    heroPlaceholder: "무엇을 도와드릴까요?",
  },
  trustBadges: {
    noLogin: "도구 사용에 로그인 불필요",
    freeUsesDaily: "하루 10회 체험 이용",
    filesNeverStored: "파일이 저장되지 않습니다",
    worksAnyDevice: "모든 기기에서 사용 가능",
    worksWhenAiBlocked: "회사의 AI 정책과 관계없이 사용 가능",
    availableInLanguages: "다양한 언어 지원",
  },
  common: {
    backToHome: "홈으로 돌아가기",
    home: "홈",
    signIn: "로그인",
    account: "계정",
    contact: "문의하기",
    blog: "블로그",
    shareThisTool: "이 도구 공유하기",
    download: "다운로드",
    copy: "복사",
    copied: "복사됨",
  },
  footer: {
    tagline: "올인원 온라인 생산성 플랫폼. 일상 업무를 위한 300개 이상의 전문 도구, 프리미엄 애플리케이션, 워크플로 제품.",
    company: "회사",
    about: "소개",
    blog: "블로그",
    contact: "문의하기",
    pricing: "가격",
    privacyPolicy: "개인정보 처리방침",
    termsOfService: "이용약관",
    allTools: "전체 도구",
    allRightsReserved: "모든 권리 보유.",
  },
  contact: {
    title: "문의하기",
    subtitle: "질문이나 의견이 있으신가요? 또는 작동하지 않는 부분이 있나요? 언제든 도와드리겠습니다.",
    email: "이메일",
    responseTime: "응답 시간",
    responseTimeValue: "일반적으로 영업일 기준 1~2일 이내에 답변드립니다.",
    sendEmail: "이메일 보내기",
    billingNote: "결제 관련 문의는 계정에 등록된 이메일 주소를 함께 알려주세요.",
    whoWeAreTitle: "FreeDailyPro 운영자",
    whoWeAreBody: "FreeDailyPro는 DreamUSA LLC가 운영하는 작고 독립적으로 운영되는 소프트웨어 사업체입니다. 그 뒤에는 큰 지원팀이 없습니다 -- 귀하의 이메일을 읽고 답장하는 사람이 도구를 만들고 유지보수하는 사람과 같아서, 가끔 답장이 즉시가 아니라 하루에서 이틀 걸릴 수 있습니다.",
    whatWeSupportTitle: "도와드릴 수 있는 부분",
    whatWeSupportBody: "300개 이상의 도구 중 어느 것이든 버그 신고, 기능 요청, 결제 및 구독 관련 문의(취소 및 환불 포함), 계정 및 로그인 문제, 무엇이 잘 작동하고 있지 않은지에 대한 일반적인 피드백을 도와드릴 수 있습니다. 도구가 잘못된 결과를 생성한 경우, 파일 유형과 무엇이 잘못되었는지 알려주시면 더 빨리 해결하는 데 도움이 됩니다.",
  },
  home: {
    heroTitleLine1: "모든 전문 업무를.",
    heroTitleLine2: "하나의 브라우저 플랫폼",
    heroSubtitle: "도구를 사용하거나, 워크플로를 실행하거나, API와 MCP로 만들거나, 저희에게 개발을 맡기세요.",
    localSignalUsedTitle: "이 기기에서 사용함",
    localSignalTryTitle: "이 중 하나를 사용해 보세요",
    localSignalBadge: "로컬 \u00b7 네트워크 불필요",
    localSignalUsedDesc: "개 도구를 이 기기에서 사용함 \u2014 브라우저 밖으로 나간 것은 없습니다",
    localSignalTryDesc: "개 도구를 아직 이 기기에서 사용 안 함 \u2014 모든 작업이 바로 이 브라우저에서 실행됩니다",
    corporateSafeTitle: "기업 환경에서도 안전",
    corporateSafeSubtitle: "회사의 AI 정책이 무엇이든, FreeDailyPro는 동일하게 작동합니다",
    corporateSafeBlockedTitle: "전면 차단",
    corporateSafeBlockedDesc: "네트워크에서 어떤 AI 도구도 허용되지 않는 경우. FreeDailyPro의 모든 도구는 그대로 작동합니다 \u2014 서버로 업로드되는 것은 전혀 없습니다.",
    corporateSafeGovernedTitle: "제한적 허용",
    corporateSafeGovernedDesc: "승인 및 검증된 도구를 통해서만 AI 사용이 허용되는 경우. 여기서는 어떠한 승인도 필요 없습니다 \u2014 검증할 외부 서버 호출 자체가 없기 때문입니다.",
    corporateSafeOpenTitle: "제한 없음",
    corporateSafeOpenDesc: "필요한 것을 자유롭게 사용하세요. 업로드하거나 기다릴 필요가 없어서 FreeDailyPro는 그만큼 더 빠릅니다.",
    corporateSafeCta: "기업용 상세 안내 전체 보기 \u2192",
    exploreToolkitTitle: "도구 모음 살펴보기",
    exploreToolkitSubtitle: "{catCount}개 카테고리에 걸친 300개 이상의 도구 \u2014 하나를 선택하거나 검색해 보세요.",
    forYourWorkTitle: "실제 업무 방식에 맞게 설계",
    forYourWorkSubtitle: "동일한 전문 도구를, 실제 직무별로 정리했습니다",
    exploreTools: "도구 살펴보기",
    seeAllRoles: "{count}개 직무 모두 보기 \u2192",
    blogTitle: "블로그 소식",
    viewAllPosts: "전체 게시글 보기",
    faqTitle: "궁금한 점이 있으신가요? FAQ를 확인해 보세요",
    faqMoreLink: "더 많은 답변을 찾고 계신가요? 전체 FAQ 보기 \u2192",
    toolkitProseTitle: "일회성 작업뿐 아니라 매일의 업무를 위한 전문 도구 모음",
    closingCtaTitle: "바로가기 추가하는 것을 잊지 마세요",
    closingCtaDesc: "한 번만 추가하면 언제나 클릭 한 번으로 접근할 수 있습니다 \u2014 데스크톱 바로가기를 설치하거나 휴대폰 홈 화면에 추가하면, 브라우저 탭을 찾을 필요 없이 FreeDailyPro가 네이티브 앱처럼 열립니다.",
    categoriesLabel: "{count}개 카테고리 \u2192",
    viewAllCategoriesLabel: "{count}개 카테고리 모두 보기 \u2192",
    yourFavorites: "즐겨찾기",
    recentlyUsed: "최근 사용",
    toolkitProsePara1: "FreeDailyPro는 PDF 편집, 이미지 변환, 동영상 자르기, 오디오 정리, 텍스트 서식 지정, 수십 가지 계산기 등 300개 이상의 일상 도구를 한곳에 모았습니다. 작업마다 다른 사이트를 오갈 필요가 없습니다. 대부분의 도구는 가입이 필요 없으며, 파일 기반 도구는 하루 10회 무료 사용을 제공합니다.",
    toolkitProsePara2: "모든 도구는 브라우저 안에서 완전히 실행됩니다. PDF를 압축하거나 사진의 배경을 제거할 때, 해당 파일은 절대 기기 밖으로 나가지 않습니다 \u2014 업로드되지 않고, 서버에서 처리되지 않으며, 어디에도 임시로라도 저장되지 않습니다. 이것은 제약이 아니라 전체 설계 방식입니다: 더 빠른 결과, 그리고 민감한 파일이라도 걱정할 필요가 없습니다.",
    toolkitProsePara3: "이런 로컬 우선 방식 덕분에 개인 노트북이든, 제한된 업무용 기기든, 엄격한 AI 사용 정책이 있는 네트워크든 FreeDailyPro는 동일하게 작동합니다 \u2014 IT 부서가 검토해야 할 외부 서버 요청 자체가 존재하지 않기 때문입니다.",
    toolkitProsePara4: "보고서를 위해 PDF를 병합하거나, 상품 등록을 위해 이미지 크기를 조정하거나, 소셜 미디어용으로 동영상 클립을 자르거나, 대출이나 세금을 빠르게 계산해야 할 때든, FreeDailyPro는 필요할 때만 기억나는 도구가 아니라 매일 사용하는 도구가 되도록 만들어졌습니다.",
    heroLaneToolsTitle: "개별 작업을 위한 전문가용 도구",
    heroLaneToolsDesc: "PDF, 이미지, 동영상 등 -- 브라우저에서 한 번의 작업으로 끝.",
    heroLaneToolsCta: "도구 둘러보기",
    heroLanePremiumTitle: "큰 작업을 위한 프리미엄 앱",
    heroLanePremiumDesc: "여러 단계의 앱: 문서, 양식, 플래너, 인쇄, 행사 서류.",
    heroLanePremiumCta: "앱 둘러보기",
    heroLaneWorkflowTitle: "워크플로 제품",
    heroLaneWorkflowDesc: "Book Writing Toolbox, Event Suite 등 -- 여러 단계를 거쳐 하나의 결과물로.",
    heroLaneWorkflowCta: "워크플로 제품 보기",
    heroLaneApiTitle: "API 및 MCP",
    heroLaneApiDesc: "직접 만든 코드나 AI 에이전트에서 동일한 도구를 호출하세요.",
    heroLaneApiCta: "개발자 페이지 열기",
    heroLaneCustomTitle: "맞춤형 소프트웨어",
    heroLaneCustomDesc: "필요한 것을 알려 주세요. 개발은 1회 비용으로 진행하고, 이후에는 소액의 월 사용료만 내시면 됩니다.",
    heroLaneCustomCta: "개발 요청하기",
  },
  install: {
    desktopTitle: "데스크톱 바로가기",
    desktopSubtitle: "클릭 한 번으로 즉시 열기",
    mobileTitle: "모바일 앱",
    mobileSubtitle: "홈 화면에 추가",
    addToHomeScreenTitle: "FreeDailyPro를 홈 화면에 추가",
    iosInstructions: "Safari에서 공유 아이콘을 탭한 다음 \"홈 화면에 추가\"를 선택하세요.",
    genericInstructions: "브라우저 메뉴를 열고 \"홈 화면에 추가\" 또는 \"앱 설치\"를 찾아보세요.",
    desktopUnavailableTitle: "이 브라우저에서는 원클릭 설치를 사용할 수 없습니다",
    desktopUnavailableDesc: "이 페이지를 북마크하거나 주소창 아이콘을 데스크톱으로 드래그할 수 있습니다.",
    desktopSuccess: "바로가기가 생성되었습니다! FreeDailyPro 아이콘을 찾아보세요.",
    mobileSuccess: "추가되었습니다! 홈 화면에서 FreeDailyPro 아이콘을 찾아보세요.",
  },
  toolPage: {
    proBadge: "Pro",
    usesRemainingToday: "오늘 체험 사용 {count}회 남음",
    whatThisToolDoes: "이 도구의 기능",
    proTips: "프로 팁",
    continueWith: "이어서 사용하기",
    moreFromCategory: "이 카테고리의 다른 도구",
  },
  usageStrip: {
    freeUsesPerDay: "체험: 하루 {limit}회",
    remainingToday: "오늘 {count}회 남음",
    dayPassLabel: "광고 없는 무제한 이용, 1일 패스 $1",
    monthlyLabel: "광고 없는 무제한 이용, 월간 패스 $4.99",
    quickBuy: "빠른 구매",
  },
  platformsBanner: {
    title: "이 API가 실제로 존재하는 곳",
    subtitle: "\"곳 출시 예정\"이라고 쓰여있는 페이지가 아닙니다 -- 오늘 바로 구독하거나 연결할 수 있는 실제 작동 중인 목록입니다.",
    postmanDetail: "바로 실행 가능한 요청, 완전한 문서 포함",
    rapidApiDetail: "Rapid 마켓플레이스를 통해 사용량 기반 요금제로 구독",
    mcpRegistryDetail: "com.freedailypro/tools로 공식 등록됨, {mcp}개 도구, 하나의 엔드포인트",
  },
  pricingBanner: {
    title: "투명한 가격 정책",
    subtitle: "숨겨진 등급도, 예상치 못한 제한도 없습니다 -- 각 플랜의 정확한 비용과 제공 내용입니다.",
    toolPricingTitle: "사용량 기반 도구 요금제",
    apiPricingTitle: "사용량 기반 API 및 MCP 요금제",
    freeLabel: "체험",
    freeToolDetail: "Professional Tools는 하루 10회, Premium Applications는 하루 2회",
    dayPassDetail: "$1/일 -- 광고 없는 무제한 이용",
    monthlyDetail: "$4.99/월 -- 광고 없는 무제한 이용",
    monthlySavingsNote: "한 달에 데이 패스 5번 사는 것보다 저렴",
    freeApiDetail: "월 20,000회 호출",
    premiumDetail: "$24/월 -- 200,000회 호출",
    ultraDetail: "$69/월 -- 750,000회 호출",
    megaDetail: "$129/월 -- 2,000,000회 호출 + 우선 처리",
  },
  apiMcpBanner: {
    title: "이제 API와 MCP를 지원합니다",
    description: "200개 이상의 도구를 직접 코드에서 호출하거나, MCP를 통해 AI 에이전트를 연결하세요 -- 브라우저만으로는 부족할 때를 위한, 서버측에서 작동하는 동일한 도구입니다.",
    oneKey: "모든 기능에 하나의 키",
    restApiMcp: "REST API + MCP",
    anyLanguage: "어떤 언어도, 어떤 서버도",
    cta: "API와 MCP 둘러보기",
  },
  premiumApps: {
    title: "프리미엄 앱",
    subtitle: "단일 동작이 아닌, 진짜 여러 단계의 애플리케이션입니다 -- 단독으로도 설치 가능합니다.",
    seeAll: "모든 프리미엄 앱 보기",
  },
  googleDrive: {
    openFromGoogle: "Google 드라이브에서 열기",
    saveToGoogle: "Google 드라이브에 저장",
    signingIn: "Google 로그인 창을 여는 중...",
    fetching: "Google 드라이브에서 파일을 가져오는 중...",
    saving: "Google 드라이브에 저장하는 중...",
    saved: "Google 드라이브에 저장했습니다",
    viewInDrive: "드라이브에서 보기",
    popupBlocked: "브라우저가 Google 로그인 창을 차단했습니다. 이 사이트의 팝업을 허용한 뒤 다시 시도하세요.",
    cancelled: "Google 로그인이 끝나기 전에 닫혔습니다. 열거나 저장한 것이 없습니다.",
    denied: "Google 드라이브 접근이 허용되지 않아 열거나 저장한 것이 없습니다. 다시 시도하고 선택한 파일에 대한 접근을 허용하세요.",
    loadFailed: "Google에 연결할 수 없습니다. 연결 상태나 콘텐츠 차단기를 확인한 뒤 다시 시도하세요.",
    network: "Google 드라이브와의 연결이 끊겼습니다. 다시 시도하세요.",
    tooLarge: "이 파일은 브라우저에서 열기에는 너무 큽니다.",
    api: "Google 드라이브에서 작업을 완료하지 못했습니다. 다시 시도하세요.",
    largeFile: "이 파일은 50MB가 넘습니다. 시간이 오래 걸리거나 브라우저 메모리가 부족할 수 있습니다.",
    privacyNote: "파일은 브라우저와 Google 사이에서만 전달되며 당사 서버로 전송되지 않습니다.",
  },
};
